/**
 * 成本核算
 */
const AccountDescRouter = {
  path: '/project',
  component: () => import('@/views/layout'),
  hidden: true,
  redirect: '/project/manage/list',
  meta: {
    title: 'desc'
  },
  children: [
    {
      path: 'costaccount/add',
      name: 'cos_taccount_add',
      hidden: true,
      component: () => import('@/views/cost_accounting/account_add'),
      meta: {
        title: '新增'
      }
    },
    {
      path: 'costaccount/edit/:id',
      name: 'cos_taccount_edit',
      hidden: true,
      component: () => import('@/views/cost_accounting/account_edit'),
      meta: {
        title: '编辑'
      }
    },
    {
      path: 'costaccount/desc/:id',
      name: 'cos_taccount_desc',
      hidden: true,
      component: () => import('@/views/cost_accounting/account_desc'),
      meta: {
        title: '详情'
      }
    }
  ]
}

export default AccountDescRouter
